import { Script } from 'gatsby'
import React from 'react'

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {/* Cookieyes consent banner. Loaded after first-paint via Gatsby's
          afterInteractive strategy so it doesn't compete with LCP. We tried
          strategy="off-main-thread" + gatsby-plugin-partytown briefly but
          the plugin's default `forward: ['dataLayer.push', ...]` config
          broke GTM-driven GA tracking (see gatsby-config.mjs comment). */}
      <Script
        key="cookieyes"
        id="cookieyes"
        src="https://cdn-cookieyes.com/client_data/2a76f6d0d3a27f892bc573d2/script.js"
        strategy="afterInteractive"
      />
      {element}
    </>
  )
}
